import { useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../hooks/useLenis";

const LINKS = [
  { label: "Expériences", href: "#experiences" },
  { label: "Équipements", href: "#equipements" },
  { label: "Tarifs", href: "#tarifs" },
  { label: "Infos", href: "#infos" },
];

export const Navbar = ({ onReserve }) => {
  const [open, setOpen] = useState(false);
  const go = (href) => {
    setOpen(false);
    scrollToId(href);
  };
  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 inset-x-0 z-50 border-b border-cyan-500/15 bg-void/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5">
        <button
          data-testid="nav-logo"
          onClick={() => go("#top")}
          className="flex items-center gap-2.5"
        >
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cyan-400 opacity-60" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-cyan-400" />
          </span>
          <span className="font-display text-lg font-extrabold tracking-widest text-slate-100">
            IMMERSION<span className="text-cyan-400">+</span>
          </span>
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="font-hud text-xs uppercase tracking-[0.2em] text-slate-400 transition-colors duration-300 hover:text-cyan-400"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="nav-reserver-btn"
            onClick={onReserve}
            className="hidden bg-cyan-400 px-5 py-2 font-hud text-xs font-bold uppercase tracking-[0.2em] text-void transition-all duration-300 hover:bg-cyan-300 hover:shadow-[0_0_24px_rgba(0,240,255,0.5)] sm:block"
          >
            Réserver
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="text-slate-300 md:hidden"
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="border-t border-line bg-void/95 px-5 py-4 backdrop-blur-xl md:hidden"
        >
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-link-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="block w-full py-3 text-left font-hud text-sm uppercase tracking-[0.2em] text-slate-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-reserver-btn"
            onClick={() => {
              setOpen(false);
              onReserve();
            }}
            className="mt-2 w-full bg-cyan-400 px-5 py-3 font-hud text-xs font-bold uppercase tracking-[0.2em] text-void"
          >
            Réserver
          </button>
        </div>
      )}
    </header>
  );
};
